import { TableRow } from "@material-ui/core";
import { memo } from "react";
import { useContasReceberService } from "../../context/ContasReceberContext";
import AccountTableCell from "./AccountTableCell";
import GroupHeaderTableRow from "./GroupHeaderTableRow";
import GroupTotalRow from "./GroupTotalRow";

const RecursiveGroupedTableRow = ({ cell, level }) => {
  const { columns, isGrouped } = useContasReceberService();

  const children = cell?.children?.map((child, childIndex) => (
    <RecursiveGroupedTableRow cell={child} level={level + 1} key={childIndex} />
  ));

  return (
    <>
      {isGrouped && (
        <GroupHeaderTableRow cell={cell} columns={columns} level={level} />
      )}
      {cell?.accounts?.map((groupedCell, groupIndex) => (
        <TableRow key={`${groupedCell.id}-${groupIndex}`}>
          {columns?.map((column) => (
            <AccountTableCell
              key={column.id}
              align={column.align}
              id={column.id}
              style={column.style}
              maxWidth={column.maxWidth}
              minWidth={column.minWidth}
              data={
                column.format
                  ? column.format(groupedCell[column.id])
                  : groupedCell[column.id]
              }
            />
          ))}
        </TableRow>
      ))}
      {children}
      {
        <GroupTotalRow
          total={cell.total}
          columns={columns}
          count={cell.accounts.length}
        />
      }
    </>
  );
};

export default memo(RecursiveGroupedTableRow);
